﻿export class User {

    Username: string;      // to be replaced by client username
    Role = -1;
    Password:string;

    constructor (type:number, username:string) {
        this.Role = -1;
        this.Username = username;
    }


    toString() {
        return this.Username + ' '+this.Role+' '+this.Password;
    }

}
